import React from 'react';

const BriefcaseIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 7.000000)'>
        <path d='M10,18.35 L8.55,17.03 C3.4,12.36 0,9.27 0,5.5 C0,2.41 2.42,0 5.5,0 C7.24,0 8.91,0.81 10,2.08 C11.09,0.81 12.76,0 14.5,0 C17.58,0 20,2.41 20,5.5 C20,9.27 16.6,12.36 11.45,17.03 L10,18.35 Z' />
      </g>
    </g>
  </svg>
);

export default BriefcaseIcon;
